import React from 'react';
import ScorecardHealthLozenge from '@atlassian/jira-compass-common/src/ui/scorecards-health-lozenge/index.tsx';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { SubtleText } from '../styled.tsx';

const messages = defineMessages({
	noScorecards: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.no-scorecards',
		defaultMessage: 'No scorecards',
		description: 'Displayed when a component has no scorecards applied.',
	},
});

type Props = {
	componentId: string;
	scorecardScores: {
		totalScore: number;
		maxTotalScore: number;
	}[];
};

export default function ScorecardCell(props: Props) {
	const { componentId, scorecardScores } = props;

	const { formatMessage } = useIntl();

	if (scorecardScores.length > 0) {
		return (
			<ScorecardHealthLozenge
				componentId={componentId}
				scorecardScores={scorecardScores}
				onClick={(_, analyticsEvent) => {
					fireUIAnalytics(analyticsEvent, 'scorecardHealthLozenge');
				}}
			/>
		);
	}

	return <SubtleText>{formatMessage(messages.noScorecards)}</SubtleText>;
}
